export const getMetricsQuery = `
  query GetMetrics {
    getMetrics {
        period {
            startDate
            endDate
        }
        createdAt
        consultations {
            totalInLifetime
            totalInPeriod
        }
        recordingTime {
            totalInLifetime
            totalInPeriod
        }
        customPrompts {
            editedDaai {
                totalInLifetime
                totalInPeriod
            }
            freeText {
                totalInLifetime
                totalInPeriod
            }
            aiGenerated {
                totalInLifetime
                totalInPeriod
            }
            all {
                totalInLifetime
                totalInPeriod
            }
        }
        yearMonth
        isFirstAccessThisPeriod
    }
}
`
